import {
  GondolaSkuSectionsResponse,
  SkuSection,
  WithIndex,
} from "@/shared/api";

export function getCameraSkuSections(
  data: GondolaSkuSectionsResponse,
  cameraId: string | null
): WithIndex<SkuSection>[] {
  return (
    data?.results
      .map((cameras, index) => ({
        ...cameras[cameraId || ""],
        index,
      }))
      .filter((item) => data.results[item.index][cameraId || ""]) || []
  );
}

export function findSkuSectionById(
  data: GondolaSkuSectionsResponse,
  cameraId: string,
  skuSectionId: number
): WithIndex<SkuSection> | null {
  const cameraSkuSections = getCameraSkuSections(data, cameraId);
  return (
    cameraSkuSections.find((item) => item.sku_section_id === skuSectionId) ||
    null
  );
}
